import React, { useEffect, useState } from "react";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { setpopupCardFooter } from "../../../../redux/features/stylesSlice";
import { useSelector } from "react-redux";
import { getConfig, searchAPI } from "../../../../apis";
import LoaderPage from "../../../../layout/LoaderPage";
import { CircularProgress } from "@mui/material";
import newsGuardImg from "../../../../media/images/newsguard2.png";
import newsGuardIcon from "../../../../media/images/neutral-shield.png";
import allSidesLogo from "../../../../media/images/AllSides-Logo.svg";
import shieldPlatformIcon from "../../../../media/images/shield-platform.svg";

import charityLogo from "../../../../media/images/charity_logo_svg.svg";
import three_star from "../../../../media/images/three_star.svg";
import four_star from "../../../../media/images/four_star.svg";
import one_star from "../../../../media/images/one_star.svg";
import zero_star from "../../../../media/images/zero_star.svg";
import two_star from "../../../../media/images/two_star.svg";

import { biasImg, biasLink } from "./CardNews";
import { logEvent } from "../../../../functions/amplitude";
import { Tooltip } from "@mui/material";
import CustomLoader from "../../../../components/loader";
import { axiosInstance } from "../../../../functions/axios";

const NewsRating = (props) => {
  const dispatch = useDispatch();

  const { popupCardFooter } = useSelector((state) => state.styles);
  const { showCharity } = useSelector((state) => state.data);

  const [data, setdata] = useState(null);

  const handleClick = (event, href, term) => {
    event.preventDefault();
    logEvent(`click_${term}`, { [term]: "clicked" });
    window.open(href, "_blank", "noopener noreferrer");
  };

  const charity_rating = () => {
    if (data.charityNavigatorScore > 90) {
      return four_star;
    } else if (data.charityNavigatorScore >= 75) {
      return three_star;
    } else if (data.charityNavigatorScore >= 60) {
      return two_star;
    } else if (data.charityNavigatorScore >= 50) {
      return one_star;
    }
    return zero_star;
  };

  const charity_text = () => {
    if (data.charityNavigatorScore >= 90) {
      return "four-star";
    } else if (data.charityNavigatorScore >= 75) {
      return "three-star";
    } else if (data.charityNavigatorScore >= 60) {
      return "two-star";
    } else if (data.charityNavigatorScore >= 50) {
      return "one-star";
    }
    return "zero-star";
  };

  useEffect(() => {
    async function getData() {
      try {
        const res = await axiosInstance.post(
          searchAPI.publisherInfo,
          {
            hostName: popupCardFooter,
          },
          getConfig()
        );

        if (res.data.success && res.data.data) {
          setdata(res.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    }

    getData();
  }, []);

  return (
    <div className="popup-footer-card">
      <div className="popup-wrapper">
        <div className="popup-container" onClick={(e) => e.stopPropagation()}>
          {data ? (
            <>
              <div
                className="cross"
                onClick={() => dispatch(setpopupCardFooter(null))}
              >
                <CloseIcon />
              </div>
              <h1 className="popup-title">{data.entityName}</h1>
              <p className="popup-desc">
                {data.wikipediaSnippet ? data.wikipediaSnippet : data.snippet}
              </p>
              <a
                className="link"
                href={data.wikipediaUrl ? data.wikipediaUrl : data.url}
                target="_blank"
                rel="noreferrer"
              >
                {data.wikipediaUrl ? "- Wikipedia" : data.entityName}
              </a>
              {data.score && <div className="line" />}
              {data.score && (
                <div className="list-header">
                  <div className="list-header-left">
                    <a
                      href={process.env.REACT_APP_NEWSGUARD_URL_RATING}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        className="newsguard-img"
                        src={newsGuardImg}
                        alt="news guard"
                        onClick={() => {
                          logEvent("click_newsguard_logo", {
                            NewsguardIcon: "clicked",
                          });
                        }}
                      />
                    </a>
                  </div>
                  <Tooltip title={data["scoreDescription"]}>
                    <h3 className="center">{data["scoreName"]}</h3>
                  </Tooltip>
                  <div className="list-header-right">
                    {Number(data.score) !== 0 ? (
                      <>
                        <img
                          className="newsguard-icon"
                          src={newsGuardIcon}
                          alt="news guard"
                        />
                        <h2>
                          {data.score}
                          <span> / 100</span>
                        </h2>
                      </>
                    ) : (
                      <img
                        className="newsguard-icon"
                        src={shieldPlatformIcon}
                        alt="news guard"
                        style={{ width: "5rem" }}
                      />
                    )}
                  </div>
                </div>
              )}
              {Number(data.score) === 0 && data.score && (
                <p className="mb-2">
                  This website is a platform that hosts content directly
                  published by users with limited vetting. Information from this
                  source may or may not be reliable.
                </p>
              )}
              {data.score && Number(data.score) !== 0 && (
                <div className="list-content">
                  <div className="list-content-left">
                    <h3>CREDIBILITY</h3>
                    <div className="list-item">
                      {data.falseContent === "Yes" ? (
                        <CheckIcon />
                      ) : data.falseContent === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}
                      <p>Does not repeatedly publish false content</p>
                    </div>
                    <div className="list-item">
                      {data.basicStandards === "Yes" ? (
                        <CheckIcon />
                      ) : data.basicStandards === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}
                      <p>Gathers and presents information responsibly</p>
                    </div>
                    <div className="list-item">
                      {data.accountabilityPractices === "Yes" ? (
                        <CheckIcon />
                      ) : data.accountabilityPractices === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>Regularly corrects or clarifies errors</p>
                    </div>
                    <div className="list-item">
                      {data.newsOpinion === "Yes" ? (
                        <CheckIcon />
                      ) : data.newsOpinion === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>
                        Handles the difference between news and opinion
                        responsibly
                      </p>
                    </div>
                    <div className="list-item">
                      {data.deceptiveHeadlines === "Yes" ? (
                        <CheckIcon />
                      ) : data.deceptiveHeadlines === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>Avoids deceptive headlines</p>
                    </div>
                  </div>
                  <div className="list-content-right">
                    <h3>TRANSPARENCY</h3>
                    <div className="list-item">
                      {data.ownership === "Yes" ? (
                        <CheckIcon />
                      ) : data.ownership === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>Website discloses ownership and financing</p>
                    </div>
                    <div className="list-item">
                      {data.labelsAdvertising === "Yes" ? (
                        <CheckIcon />
                      ) : data.labelsAdvertising === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>Clearly labels advertising</p>
                    </div>
                    <div className="list-item">
                      {data.management === "Yes" ? (
                        <CheckIcon />
                      ) : data.management === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>
                        Reveals who's in charge, including any possible
                        conflicts of interest
                      </p>
                    </div>
                    <div className="list-item">
                      {data.contentCreators === "Yes" ? (
                        <CheckIcon />
                      ) : data.contentCreators === "No" ? (
                        <CloseIcon className="red" />
                      ) : (
                        <p className="na">NA</p>
                      )}

                      <p>
                        This site provides the names of content creators, along
                        with either contact or bigraphical information
                      </p>
                    </div>
                  </div>
                </div>
              )}
              {data.nutritionLink && data.score && (
                <a
                  className="center-link link mb-1"
                  href={data.nutritionLink}
                  onClick={(e) =>
                    handleClick(
                      e,
                      data.nutritionLink,
                      "newsguard_nutritionlabel"
                    )
                  }
                  target="_blank"
                  rel="noreferrer"
                >
                  See the full Nutrition Label
                </a>
              )}
              {data.score && (
                <a
                  className="center-link link"
                  href={process.env.REACT_APP_NEWSGUARD_URL_RATING}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) =>
                    handleClick(
                      e,
                      process.env.REACT_APP_NEWSGUARD_URL_RATING,
                      "newsguard_about"
                    )
                  }
                >
                  Learn more about NewsGuard
                </a>
              )}
              {data.allsidesUrl && <div className="line" />}
              {data.mediaBiasRating && (
                <div className="footer-popup">
                  <div className="img">
                    <a
                      href={process.env.REACT_APP_ALLSIDES_URL}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={allSidesLogo}
                        onClick={() => {
                          logEvent("click_allsides_logo", {
                            AllSidesIcon: "clicked",
                          });
                        }}
                        alt="logo"
                      />
                    </a>
                  </div>
                  <div className="buttons">
                    <img
                      className="bias"
                      src={biasImg[data.mediaBiasRating]}
                      alt="bias"
                    />
                  </div>
                </div>
              )}
              {data.mediaBiasRating && (
                <h3 className="desc-link">
                  AllSides Media Bias Rating:{" "}
                  <a
                    href={biasLink[data.mediaBiasRating]}
                    onClick={(e) =>
                      handleClick(
                        e,
                        biasLink[data.mediaBiasRating],
                        "allsides_mediabiasrating"
                      )
                    }
                    target="_blank"
                    rel="noreferrer"
                  >
                    {data.mediaBiasRating}
                  </a>
                </h3>
              )}
              {data.allsidesUrl && (
                <a
                  className="link center-link mb-1"
                  href={data.allsidesUrl}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) =>
                    handleClick(e, data.allsidesUrl, "allsides_newssource")
                  }
                >
                  See the AllSides news source page
                </a>
              )}
              {data.allsidesUrl && (
                <a
                  className="link center-link"
                  href={process.env.REACT_APP_ALLSIDES_ABOUT}
                  target="_blank"
                  rel="noreferrer"
                  onClick={(e) =>
                    handleClick(
                      e,
                      process.env.REACT_APP_ALLSIDES_ABOUT,
                      "allsides_about"
                    )
                  }
                >
                  Learn more about AllSides
                </a>
              )}
              {console.log("charity", showCharity)}
              {showCharity && (
                <>
                  {data.charityNavigatorRating && <div className="line" />}
                  {data.charityNavigatorRating && (
                    <div className="flex-footer">
                      <div className="">
                        <a
                          href={process.env.REACT_APP_CHARITY_URL_ABOUT}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            src={charityLogo}
                            className="charity-logo"
                            alt="logo"
                          />
                        </a>
                      </div>
                      <div className="buttons">
                        <p className="charity-score">
                          {data.charityNavigatorScore}%
                        </p>
                        <img
                          className="charity-rating"
                          src={charity_rating()}
                          alt="bias"
                        />
                      </div>
                    </div>
                  )}
                  <p className="popup-desc">
                    {data.charityNavigatorRating &&
                      `The Charity Score is ${
                        data.charityNavigatorScore
                      }%, earning it a ${charity_text()} rating.`}
                  </p>
                  {data.charityNavigatorEIN && (
                    <a
                      className="link center-link mb-1"
                      href={data.charityNavigatorEIN}
                      target="_blank"
                      rel="noreferrer"
                    >
                      See the full Charity Navigator review
                    </a>
                  )}
                  {data.charityNavigatorRating && (
                    <a
                      className="link center-link"
                      href={process.env.REACT_APP_CHARITY_URL_RATING}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Learn more about Charity Navigator and its rating
                      methodology
                    </a>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="loading">
              <div
                className="cross"
                onClick={() => dispatch(setpopupCardFooter(null))}
              >
                <CloseIcon />
              </div>
              <CustomLoader />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsRating;
